export default "__VITE_ASSET__STwPl7JC__"